export interface AppointmentWizardTime {
    id: string /** id de la entity (creada a mano para tener una clave primaria) */;
    clinicId: string /** Id de la clínica donde está esta hora asociada */;
    cabinetId: string /** Id de la cabina donde está esta hora asociada */;
    date: string /** Fecha de la hora */;
    timeStart: string /** Hora de inicio del hueco disponible */;
    timeEnd: string /** Hora fin del hueco disponible */;
    totalWait: string /** Tiempo de espera entre cada grupo de servicios SOLO PARA COMPUESTAS */;
    servicesGroup: any /** Objeto que SOLO necesitamos para guardar la cita, SOLO PARA COMPUESTAS */;
}

/**
 * A factory function that creates AppointmentWizardTime
 */
export function createAppointmentWizardTime(
    params: Partial<AppointmentWizardTime>
) {
    return {} as AppointmentWizardTime;
}

/**
 * Factoría que crea una Appointment con los datos recogidos por la API
 */
export function appointmentWizardTimeFactory(params: any) {
    return {
        id: params.ClinicID + '_' + params.Date + '_' + params.TimeStart,
        clinicId: params.ClinicID,
        cabinetId: params.CabineID,
        date: params.Date,
        timeStart: params.TimeStart,
        timeEnd: params.TimeEnd,
        totalWait: params.TotalWait,
        servicesGroup: params.ServicesGroups,
    } as AppointmentWizardTime;
}
